module.exports = __webpack_public_path__ + "ath_game_web/img/5.2.bfae0733.png";